/**
 * Creates a throttled function that only invokes func at most once per every threshold milliseconds.
 *
 * @param {T} callback - The function to throttle.
 * @param {number} threshold - The number of milliseconds to throttle invocations to.
 * @return {Function} - The new throttled function.
 */
export function throttle<T extends (...args: unknown[]) => unknown>(callback: T, threshold: number): T {
  let deferTimer: NodeJS.Timeout | null = null;
  let lastRun = 0;

  return function (this: unknown, ...args: unknown[]) {
    const now = Date.now();

    if (lastRun && now < lastRun + threshold) {
      if (deferTimer) {
        clearTimeout(deferTimer);
      }
      deferTimer = setTimeout(() => {
        lastRun = now;
        callback.apply(this, args);
      }, threshold);
    } else {
      lastRun = now;
      callback.apply(this, args);
    }
  } as T;
}
